import React, { useEffect, useState } from 'react'

import {
    Card, Typography, Paper, Grid, Stack, CardMedia, Button,
    Select, FormControl, MenuItem, useMediaQuery, Avatar, IconButton, InputAdornment, TextField, ClickAwayListener, CircularProgress,
} from '@mui/material';

import Header from "../components/Header";
import Footer from "../components/Footer";
import SEO from '../components/SEO';

import { Box } from '@mui/system';
import { ReactComponent as Empty } from "../assets/svg/empty.svg";
import { ReactComponent as Searching } from "../assets/svg/searching_illustration.svg";

import { useDispatch, useSelector } from 'react-redux';
import { getCollections } from '../redux/actions/collectionAction';
import { getBooks, selectBook } from '../redux/actions/bookAction';
import { useHistory } from 'react-router-dom';
import BookDisplay from '../components/dialogs/BookDisplay';
import { addViews } from '../utils/firebase';
import { getAuth } from 'firebase/auth';
import { Search } from '@mui/icons-material';

export default function LibraryCollection() {
    const matches = useMediaQuery((theme) => theme.breakpoints.up('md'));
    const match = useMediaQuery((theme) => theme.breakpoints.down('md'));

    const [loading, setLoading] = useState(true)
    const [user, setUser] = useState(false);
    const fullScreen = useMediaQuery('(min-width:660px)');
    const collection = useSelector((state => state.collection))
    const book = useSelector((state => state.book))
    const [selectedCollection, setSelectedCollection] = useState("None");
    const [displayCollection, setDisplayCollection] = useState({});
    const handleCollection = (e) => {
        setSelectedCollection(e.target.value)
        for (var x = 0; x < collections.length; x++) {
            if (collections[x].id === e.target.value) {
                setDisplayCollection(collections[x])
            }
        }
        if (e.target.value === "None") {
            setDisplayCollection({})
        }
    }

    const listCollections = book.books
    const collections = collection.collections
    const style = {
        background: {
            paddingLeft: 2,
            paddingRight: 2,
            borderRadius: 0,
            paddingBottom: 0,
            paddingTop: 5,
            '@media only screen and (max-width: 900px)': {
                paddingTop: 2
            }
        },
        iconCenter: {
            width: 100,
            height: 100,
            marginBottom: 5,
            display: "flex",
        },
        body: {
            '@media only screen and (min-width: 480px)': {
                marginLeft: '4%',
                marginRight: '4%',
            },
            '@media only screen and (min-width: 1700px)': {
                marginLeft: '15%',
                marginRight: '15%',
            },
        },
        cardStyle: {
            opacity: 0.9,
            minHeight: 0,
            width: 95,
            height: 95,
            marginBottom: 5,
            textAlign: "center",
            '@media only screen and (max-width: 900px)': {
                width: 70,
                height: 70
            }
        },
        typography: {
            textAlign: "center",
            fontFamily: "Helvetica Neue",
            fontWeight: "bold",
            paddingBottom: 2,
            '@media only screen and (max-width: 900px)': {
                paddingBottom: 0,
                fontSize: 45,
                textAlign: "left"
            }
        },
        footerStyle: {
            position: "fixed",
            left: 0,
            bottom: 0,
            width: "100%",
            textAlign: "center"
        },
        label: {
            fontFamily: "Helvetica Neue",
            fontWeight: "bold",
            paddingBottom: 4,
        },
        divider: {
            marginTop: 4,
            marginBottom: 4
        },
        labelSmall: {
            paddingBottom: 3
        },
        bodyText: {
            fontFamily: "Helvetica Neue",
            paddingBottom: 4,
            marginTop: 1,
            '@media only screen and (max-width: 900px)': {
                paddingBottom: 2
            }
        },
        textInstruction: {
            paddingTop: 2
        },
        textPenalty: {
            textAlign: "center",
            paddingBottom: 1
        },
        reserveButton: {
            borderRadius: 5,
            fontWeight: "bold",
            backgroundColor: (theme) => theme.palette.primary.light,
            color: (theme) => theme.palette.common.white,
            border: "3px white solid",
            paddingLeft: 5,
            paddingRight: 5,
            boxShadow: 3,
            "&:hover": {
                backgroundColor: (theme) => theme.palette.primary.main,
            },
        },
        buttonTable: {
            borderRadius: 5,
            margin: 2,
            fontWeight: "bold",
            backgroundColor: (theme) => theme.palette.primary.light,
            color: (theme) => theme.palette.common.white,
            border: "3px white solid",
            paddingLeft: 2,
            paddingRight: 2,
            boxShadow: 3,
            "&:hover": {
                backgroundColor: (theme) => theme.palette.primary.main,
            },
        },
        textTable: {
            margin: 0,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
        }
    }
    const [selectedBook, setSelectedBook] = useState({})
    const [open, setOpen] = useState(false);
    const displayBook = (bookObject) => (e) => {
        e.preventDefault();
        setOpen(true);
        if (bookObject) {
            setSelectedBook(bookObject);
            addViews(bookObject.bookID);
        }

    }
    const dispatch = useDispatch();

    const history = useHistory();
    const reserveBook = (bookObject) => (e) => {
        if (bookObject) {
            dispatch(selectBook(bookObject));
            history.push("/reservation")
        }
    }

    const handleInputChange = (prop) => (e) => {
        setPayload({ ...payload, [prop]: e.target.value });
        setData(
            listCollections.filter(
                (item) =>
                    item.bookTitle.toLowerCase().search(
                        e.target.value.toLowerCase()
                    ) !== -1 ||
                    item.bookAuthor.toLowerCase().search(
                        e.target.value.toLowerCase()
                    ) !== -1
            )
        )
    }

    const [payload, setPayload] = useState({
        search: ""
    })
    const [search, setSearch] = useState(false);
    //data not loading properly
    const firstIndex = 0;
    const [pageSize, setPageSize] = useState(6);
    const [data, setData] = useState(listCollections.slice(firstIndex, pageSize));


    useEffect(() => {
        if (getAuth().currentUser) setUser(true)
        if (!collection.collectionEmpty && collection.collections.length <= 0) {
            dispatch(getCollections());
        } 
        if (!book.bookEmpty && book.books.length <= 0){ 
            dispatch(getBooks());
            setLoading(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    //console.log(book.books.length<=0 && !book.bookEmpty)
    

    const searchActive = (e) => {
        e.preventDefault();
        setDisplayCollection({})
        setSelectedCollection("None")
        setSearch(true);
    }

    const seeMore = (e) => {
        e.preventDefault();
        var tempPage = pageSize + 1;
        setPageSize(tempPage)
    }

    const handleClickAway = () => {
        setSearch(false);
    };

    return (
        <Box>
            <SEO title="Library Collection - Baliwag Municipal Library" description="The Library Collections of the Baliwag Municipal Library" />
            <Paper sx={style.background} elevation={0}>
                <Header />
                <Box sx={style.body}>
                    <Typography sx={style.typography} variant="h4" color="default">Library Collections</Typography>
                    {search ?
                        <ClickAwayListener onClickAway={handleClickAway}>
                            <TextField
                                autoFocus={search}
                                fullWidth
                                placeholder='Search for Books...'
                                size='small'
                                onChange={handleInputChange("search")}
                                sx={{ marginBottom: 2 }}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Search sx={{ color: (theme) => theme.palette.borderColor.primary }} />
                                        </InputAdornment>
                                    ),
                                }} />
                        </ClickAwayListener>
                        :
                        <Button
                            startIcon={<Search sx={{ height: 25, width: 25 }} />}
                            variant='outlined'
                            color="primary"
                            fullWidth
                            onClick={searchActive}
                            disableRipple
                            sx={{
                                paddingTop: 0.7,
                                paddingBottom: 0.7,
                                color: (theme) => theme.palette.borderColor.primary,
                                fontSize: 16,
                                borderColor: (theme) => theme.palette.borderColor.primary,
                                justifyContent: "flex-start",
                                textTransform: 'none',
                                "&:hover": {
                                    backgroundColor: "transparent",
                                    borderColor: (theme) => theme.palette.text.primary,
                                },
                            }}
                        > Search for Books...
                        </Button>
                    }
                    <Stack direction="row" alignItems="center" sx={{ marginTop: 2, marginBottom: 2 }}>
                        <Box component="span" sx={{ flexGrow: 1 }} />
                        <Typography variant='body1' >Collection: </Typography>
                        <FormControl sx={{ m: 1, minWidth: 200 }} size="small">
                            <Select
                                displayEmpty
                                onChange={handleCollection}
                                value={selectedCollection}
                                inputProps={{ 'aria-label': 'Without label' }}
                            >
                                <MenuItem value="None">None</MenuItem>
                                {Array.from(collections).map((_, index) => (
                                    <MenuItem value={collections[index].id} key={index}>{collections[index].collectionTitle}</MenuItem>
                                ))}

                            </Select>
                        </FormControl>
                    </Stack>
                    <Box sx={{
                        flexGrow: 1,
                        paddingBottom: 1,
                        paddingLeft: matches ? "15%" : "2",
                        paddingRight: matches ? "15%" : "2",
                    }}>
                        {Object.keys(displayCollection).length > 0 && <Card variant="outlined" sx={{ minHeight: 150, paddingTop: 1 }}>
                            <Grid container columns={12} alignItems="center" spacing={1}>
                                <Grid item xs={12} md={3}>
                                    <CardMedia
                                        sx={{ width: 100, margin: "auto" }}
                                        component="img"
                                        height="140"
                                        image={displayCollection.collectionCover}
                                    />
                                </Grid>
                                <Grid item xs={12} md={9}>
                                    <Typography variant='h5'
                                        sx={{ fontWeight: "bold", textAlign: "center", margin: 0 }}>
                                        {displayCollection.collectionTitle}
                                    </Typography>
                                    <Typography variant="body1" sx={{ textAlign: "center" }}>
                                        {displayCollection.collectionDesc}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Card>}
                    </Box>
                    {Object.keys(displayCollection).length > 0 &&
                        <Box sx={{
                            flexGrow: 1,
                            marginTop: 1,
                            paddingBottom: 1,
                            paddingLeft: matches ? 6 : "2",
                            paddingRight: matches ? 6 : "2",
                        }}>
                            <Stack direction="column" spacing={1}>
                                <Grid container columns={12} alignItems="center" spacing={1}>
                                    {fullScreen && <Grid item xs={2} >
                                        <Box component="span" sx={{ flexGrow: 1 }} />
                                    </Grid>}
                                    <Grid item xs={4}>
                                        <Typography variant='body1'
                                            sx={{ margin: 0, fontWeight: "bold", textAlign: "left" }}>
                                            BOOK TITLE
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Typography variant='body1'
                                            sx={{ margin: 0, fontWeight: "bold", textAlign: "left" }}>
                                            AUTHOR
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={3} >
                                        <Box component="span" sx={{ flexGrow: 1 }} />
                                    </Grid>
                                </Grid>
                            </Stack>
                        </Box>
                    }
                    <Grid container columns={12} spacing={2}>
                        {listCollections.length > 0 ?
                            !search ? Array.from(listCollections).map((_, index) => (
                                listCollections[index].collectionID === selectedCollection || selectedCollection === "None" ?
                                    index < pageSize &&
                                        fullScreen ?
                                        <Grid item xs={12} key={index}>
                                            <Card
                                                variant="outlined"
                                                onClick={displayBook(listCollections[index])}
                                                sx={{
                                                    marginBottom: 1,
                                                    "&:hover": {
                                                        cursor: "pointer",
                                                        boxShadow: 1
                                                    },
                                                }}>
                                                <Grid container columns={12} alignItems="center" spacing={1}>
                                                    <Grid item xs={2} >
                                                        <IconButton
                                                            disableRipple
                                                            sx={{
                                                                "&:hover": {
                                                                    backgroundColor: "transparent",
                                                                },
                                                            }}>
                                                            <Avatar
                                                                variant="square"
                                                                sx={{
                                                                    width: 70,
                                                                    height: 90,
                                                                    margin: "auto",
                                                                }}
                                                                src={listCollections[index].bookCover || ".././assets/images/default_book.png"}
                                                            />
                                                        </IconButton>
                                                    </Grid>
                                                    <Grid item xs={4} sx={{ textAlign: "left" }}>
                                                        <Typography variant='body2'
                                                            sx={{ ...style.textTable, marginLeft: fullScreen ? 4 : 1 }}>
                                                            {listCollections[index].bookTitle}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={3} sx={{ textAlign: "left" }}>
                                                        <Typography variant='body2'
                                                            sx={style.textTable}>
                                                            {listCollections[index].bookAuthor}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={3} sx={{ display: "inline" }}>
                                                        <Button
                                                            disabled={!user}
                                                            variant="contained"
                                                            sx={style.buttonTable}
                                                            onClick={reserveBook(listCollections[index])}>
                                                            Reserve
                                                        </Button>
                                                    </Grid>
                                                </Grid>

                                            </Card>
                                        </Grid> :
                                        !fullScreen && index < pageSize &&
                                        <Grid item xs={4} key={index}>
                                            <Stack direction="column" alignItems="center">
                                                <IconButton
                                                    onClick={displayBook(listCollections[index])}
                                                    disableRipple
                                                    sx={{
                                                        "&:hover": {
                                                            backgroundColor: "transparent",
                                                        },
                                                    }}>
                                                    <Avatar
                                                        variant="square"
                                                        sx={{
                                                            width: 70,
                                                            height: 90,
                                                            margin: "auto",
                                                        }}
                                                        src={listCollections[index].bookCover || ".././assets/images/default_book.png"}
                                                    />
                                                </IconButton>
                                                <Typography variant='body2'
                                                    sx={{ ...style.textTable, marginLeft: fullScreen ? 4 : 1 }}>
                                                    {listCollections[index].bookTitle}
                                                </Typography>
                                                <Typography variant='body2'
                                                    sx={{ ...style.textTable, fontSize: 12 }}>
                                                    by: {listCollections[index].bookAuthor}
                                                </Typography>
                                            </Stack>
                                        </Grid>
                                    : <Box />
                            ))
                                :
                                payload.search !== "" ?
                                    <Grid container columns={12} spacing={2}>
                                        {Array.from(data).map((_, index) => (
                                            fullScreen ? <Grid item xs={12} key={index}>
                                                <Card
                                                    key={index}
                                                    variant="outlined"
                                                    onClick={displayBook(data[index])}
                                                    sx={{
                                                        marginBottom: 1,
                                                        "&:hover": {
                                                            cursor: "pointer",
                                                            boxShadow: 1
                                                        },
                                                    }}>
                                                    <Grid container columns={12} alignItems="center" spacing={1}>
                                                        {fullScreen && <Grid item xs={2} >
                                                            <IconButton
                                                                sx={{
                                                                    "&:hover": {
                                                                        backgroundColor: "transparent",
                                                                    },
                                                                }}>
                                                                <Avatar
                                                                    variant="square"
                                                                    sx={{
                                                                        width: 70,
                                                                        height: 90,
                                                                        margin: "auto",
                                                                    }}
                                                                    src={data[index].bookCover || ".././assets/images/default_book.png"}
                                                                />
                                                            </IconButton>
                                                        </Grid>}
                                                        <Grid item xs={4} sx={{ textAlign: "left" }}>
                                                            <Typography variant='body2'
                                                                sx={style.textTable}>
                                                                {data[index].bookTitle}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={3} sx={{ textAlign: "left" }}>
                                                            <Typography variant='body2'
                                                                sx={style.textTable}>
                                                                {data[index].bookAuthor}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={3} sx={{ display: "inline" }}>
                                                            <Button
                                                                disabled={!user}
                                                                variant="contained"
                                                                sx={style.buttonTable}
                                                                onClick={reserveBook(data[index])}>
                                                                Reserve
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                </Card>
                                            </Grid> :
                                                <Grid item xs={4} key={index}>
                                                    <Stack direction="column" alignItems="center">
                                                        <IconButton
                                                            onClick={displayBook(data[index])}
                                                            disableRipple
                                                            sx={{
                                                                "&:hover": {
                                                                    backgroundColor: "transparent",
                                                                },
                                                            }}>
                                                            <Avatar
                                                                variant="square"
                                                                sx={{
                                                                    width: 70,
                                                                    height: 90,
                                                                    margin: "auto",
                                                                }}
                                                                src={data[index].bookCover || ".././assets/images/default_book.png"}
                                                            />
                                                        </IconButton>
                                                        <Typography variant='body2'
                                                            sx={{ ...style.textTable, marginLeft: fullScreen ? 4 : 1 }}>
                                                            {data[index].bookTitle}
                                                        </Typography>
                                                        <Typography variant='body2'
                                                            sx={{ ...style.textTable, fontSize: 12 }}>
                                                            by: {data[index].bookAuthor}
                                                        </Typography>
                                                    </Stack>
                                                </Grid>
                                        ))}
                                    </Grid>
                                    :
                                    <Grid
                                        container
                                        columns={12}
                                        alignItems="center"
                                        justifyContent="center"
                                        sx={{ marginTop: match ? 3 : 0 }}
                                    >
                                        <Grid item xs={12} sx={{ textAlign: "center" }}>
                                            <Searching
                                                style={{
                                                    height: match ? "68%" : "50%",
                                                    width: match ? "68%" : "50%"
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sx={{ textAlign: "center" }}>
                                            <Typography variant="h5"
                                                sx={{
                                                    fontWeight: "bold",
                                                    opacity: 0.7,
                                                }}
                                            >
                                                Start Searching!
                                            </Typography>
                                            <Typography variant="subtitle1"
                                                sx={{
                                                    fontSize: 15,
                                                    opacity: 0.7,
                                                }}
                                            >
                                                Start typing to discover more books.
                                            </Typography>
                                        </Grid>
                                    </Grid>
                            :
                            !loading && book.bookEmpty ? <Grid
                                container
                                columns={12}
                                alignItems="center"
                                justifyContent="center"
                                sx={{ marginTop: match ? 3 : 0 }}
                            >
                                <Grid item xs={12} sx={{ textAlign: "center" }}>
                                    <Empty
                                        style={{
                                            height: match ? "68%" : "50%",
                                            width: match ? "68%" : "50%"
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sx={{ textAlign: "center" }}>
                                    <Typography variant="h5"
                                        sx={{
                                            fontWeight: "bold",
                                            opacity: 0.7,
                                        }}
                                    >
                                        There are no listed books!
                                    </Typography>
                                    <Typography variant="subtitle1"
                                        sx={{
                                            fontSize: 15,
                                            opacity: 0.7,
                                        }}
                                    >
                                        We're sorry but there are no available books as of the moment.
                                    </Typography>
                                </Grid>
                            </Grid> :
                                <Grid
                                    container
                                    direction="column"
                                    columns={12}
                                    alignItems="center"
                                    justifyContent="center"
                                    sx={{ marginTop: "5%" }}
                                >
                                    <Grid item xs>
                                        <CircularProgress />
                                    </Grid>
                                </Grid>
                        }
                    </Grid>
                    {listCollections.length > pageSize && <Box sx={{ display: "flex", justifyContent: "center" }}>
                        <Button
                            onClick={seeMore}
                            disableRipple
                            fullWidth>
                            See More...
                        </Button>
                    </Box>}
                </Box>
                <Box sx={{ height: 100 }} />
            </Paper>
            <Box sx={style.footerStyle}>
                <Footer />
            </Box>
            <BookDisplay open={open} setOpen={setOpen} bookObject={selectedBook} />
        </Box>
    )
}
